import { ApolloClient, InMemoryCache, gql, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getApiBaseUrl } from '../config/appConfig';

// Admin GraphQL endpoint configuration
const ADMIN_GRAPHQL_ENDPOINT = `${getApiBaseUrl()}/graphql-admin`;

console.log('Using Admin GraphQL Endpoint:', ADMIN_GRAPHQL_ENDPOINT);

// Create HTTP link to the Admin GraphQL API
const httpLink = createHttpLink({
  uri: ADMIN_GRAPHQL_ENDPOINT,
});

// Auth link with bearer token authentication (placeholder, update as needed)
const authLink = setContext((_, { headers }) => {
  // TODO: Integrate MSAL token acquisition if needed
  return {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${token}` // Add token logic if required
    }
  };
});

// Apollo Client instance for admin endpoint
const adminClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: { errorPolicy: 'all' },
    query: { errorPolicy: 'all' },
  },
});

export default adminClient;
export { gql };